__turbopack_context__.v({
  "Text": "TreeItem-module__UmvCcW__Text",
  "TreeItem": "TreeItem-module__UmvCcW__TreeItem",
  "Wrapper": "TreeItem-module__UmvCcW__Wrapper",
  "clone": "TreeItem-module__UmvCcW__clone",
});
